import { type FC, type ReactNode } from "react";

import { Button } from "@snapchat/snap-design-system";

import { Flexbox } from "../../shared/components";

import {
    ButtonsContainer,
    LensPreviewFormContainer,
    LensPreviewFormTitle,
    LensPreviewText,
    lensPreviewContent,
    lensPreviewFormHeader,
} from "./LensPreviewForm.styles";

interface LensPreviewFormProps {
    onApply: () => void;
    onCancel: () => void;
    isFormPending: boolean;
    isApplyDisabled: boolean;
    children?: ReactNode;
    isCancelDisabled?: boolean;
}

export const LensPreviewForm: FC<LensPreviewFormProps> = ({
    onApply,
    onCancel,
    isFormPending,
    isApplyDisabled,
    isCancelDisabled,
    children,
}) => (
    <LensPreviewFormContainer>
        <div className={lensPreviewFormHeader}>
            <LensPreviewFormTitle>Lens Preview</LensPreviewFormTitle>
            <LensPreviewText>
                Previews make your Lens more compelling and will be visible to the public.
            </LensPreviewText>
        </div>

        <Flexbox className={lensPreviewContent}>{children}</Flexbox>

        <ButtonsContainer>
            <Button onClick={onCancel} isDisabled={isCancelDisabled}>
                Cancel
            </Button>
            <Button onClick={onApply} isDisabled={isApplyDisabled} isPending={isFormPending} type="primary">
                Apply
            </Button>
        </ButtonsContainer>
    </LensPreviewFormContainer>
);
